import { Icon20InfoCircleOutline } from '@vkontakte/icons';
import classNames from 'clsx';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { fullTariff, trialTariff } from 'reactApp/appHelpers/featuresHelpers/features/publicDownloadLimits';
import { loadPaidInfoRequest } from 'reactApp/modules/paidInfo/paidInfo.module';
import { PaidInfoSelectors } from 'reactApp/modules/paidInfo/paidInfo.selectors';
import { loadProductsAndOpenFastCheckout } from 'reactApp/modules/payment/payment.module';
import { sendDwh } from 'reactApp/utils/ga';

import styles from './InformerLimitSharing.css';

export type InformerLimitSharingProps = {
    isMobile?: boolean;
    total: number;
};

const sendAnalytics = (action) => {
    sendDwh({ eventCategory: 'informer-limit-sharing', action });
};

export const InformerLimitSharing = ({ isMobile, total }: InformerLimitSharingProps) => {
    const dispatch = useDispatch();
    const isUserWithoutPayment = useSelector(PaidInfoSelectors.isUserWithoutPayment);
    const productId = isUserWithoutPayment ? trialTariff : fullTariff;

    useEffect(() => {
        emitAnalyticEvent(AnalyticEventNames.INFORMER_SHARING_SHOW);
        sendAnalytics('show');
        dispatch(loadPaidInfoRequest());
    }, [dispatch]);

    const handleClickBye = useCallback(() => {
        emitAnalyticEvent(AnalyticEventNames.INFORMER_SHARING_CLICK);
        sendAnalytics('click');
        dispatch(
            loadProductsAndOpenFastCheckout({
                productId,
                paySource: 'limit_sharing_modal_inf',
                title: 'Подписка Mail Space: скачивания без лимита и другие опции',
                hideOtherTariffs: true,
            })
        );
    }, [productId]);

    const renderText = () => {
        return isMobile ? (
            <>
                Сегодня файлы скачали {total}&nbsp;раз из&nbsp;{total}. <br />
                Оформите подписку, чтобы снять лимит
            </>
        ) : (
            <>
                Сегодня получатели скачали {total}&nbsp;раз из&nbsp;{total}. Оформите подписку Mail Space, чтобы снять лимит.
            </>
        );
    };

    return (
        <div className={classNames(styles.info, { [styles.infoMobile]: isMobile })}>
            <Icon20InfoCircleOutline className={styles.iconInfo} />
            <div className={classNames(styles.content, { [styles.contentMobile]: isMobile })}>
                <span className={styles.text}>{renderText()}</span>
                <a onClick={handleClickBye} className={styles.link}>
                    {isUserWithoutPayment ? ' Попробовать за 1 ₽' : ' Попробовать'}
                </a>
            </div>
        </div>
    );
};
